<template>
  <div class="merchantDetails">
    <el-card class="searchCard" shadow="never">
      <el-tabs v-model="activeName" v-if="merchantId !== ''">
        <el-tab-pane label="商户详情" name="info"></el-tab-pane>
        <el-tab-pane label="费率信息" name="rate"></el-tab-pane>
        <!-- <el-tab-pane label="蓝海行动资料" name="blueSea" v-if="blueSeaInfo"></el-tab-pane>
        <el-tab-pane label="绿洲计划资料" name="oasis" v-if="oasis"></el-tab-pane> -->

        <info-form
          v-show="activeName === 'info'"
          :read-only="readOnly"
          :is-edit="isEdit"
          :id="merchantId"
          :submit-loading="buttonLoading"
          :is-merchant="true"></info-form>
        <rate-form v-show="activeName === 'rate'" v-if="hasGetRate" :read-only="readOnly" :is-edit="isEdit" :id="merchantId"></rate-form>

        <el-form v-loading="loading" v-show="activeName === 'blueSea'" v-if="blueSeaInfo">
          <h3 style="margin-bottom:14px">蓝海行动证照信息</h3>
          <div class="photos-content-view">
            <el-form-item label="">
              <upload-img-ele
                label="收银台照(含支付宝相关物料)"
                v-model="blueSeaInfo.cashierDeskForAliPay"
                :disabled="true"
                :value="blueSeaInfo.cashierDeskForAliPay"
                valueName="blueSeaInfo.cashierDeskForAliPay"
                iconType="el-icon-picture"></upload-img-ele>
            </el-form-item>
            <el-form-item label="">
              <upload-img-ele
                label="第三方平台入驻照"
                v-model="blueSeaInfo.thirdPlatformSettledPic"
                :disabled="true"
                :value="blueSeaInfo.thirdPlatformSettledPic"
                valueName="blueSeaInfo.thirdPlatformSettledPic"
                iconType="el-icon-picture"></upload-img-ele>
            </el-form-item>
          </div>
        </el-form>

        <el-form v-loading="loading" label-position="left" label-width="120px" v-show="activeName === 'oasis'" v-if="oasis">
          <h3 style="margin-bottom:14px">绿洲计划证照信息</h3>
          <el-form>
            <div class="photos-content-view">
              <el-form-item label="">
                <upload-img-ele
                  label="收银台照(含支付宝相关物料)"
                  v-model="oasis.checkstandForOasis"
                  :disabled="true"
                  :value="oasis.checkstandForOasis"
                  valueName="oasis.checkstandForOasis"
                  iconType="el-icon-picture"></upload-img-ele>
              </el-form-item>
              <el-form-item label="">
                <upload-img-ele
                  label="店内拍摄营业执照"
                  v-model="oasis.businessLicenseForOasis"
                  :disabled="true"
                  :value="oasis.businessLicenseForOasis"
                  valueName="oasis.businessLicenseForOasis"
                  iconType="el-icon-picture"></upload-img-ele>
              </el-form-item>
              <el-form-item label="">
                <upload-img-ele
                  label="第三方平台入驻照"
                  v-model="oasis.settledForOasis"
                  :disabled="true"
                  :value="oasis.settledForOasis"
                  valueName="oasis.settledForOasis"
                  iconType="el-icon-picture"></upload-img-ele>
              </el-form-item>
              <el-form-item label="">
                <upload-img-ele
                  label="BD与商户门头照"
                  v-model="oasis.bdMerchantHeadForOasis"
                  :disabled="true"
                  :value="oasis.bdMerchantHeadForOasis"
                  valueName="oasis.bdMerchantHeadForOasis"
                  iconType="el-icon-picture"></upload-img-ele>
              </el-form-item>
            </div>
          </el-form>
        </el-form>
      </el-tabs>
    </el-card>
  </div>
</template>
<script>
import infoForm from '@/views/merchant/components/infoForm'
import rateForm from '@/views/merchant/components/rateForm'
import uploadImgEle from '@/components/upload/uploadImgEle'
import { getMerchantInfo } from '@/api/merchant.js'
import qs from 'qs'
export default {
  name: 'Details',
  components: {
    infoForm,
    rateForm,
    uploadImgEle
  },
  data () {
    return {
      activeName: 'info',
      buttonLoading: false, // 按钮加载中
      readOnly: '',
      isEdit: '',
      merchantId: '', // 商户id
      hasGetRate: false, // 是否已加载费率信息
      loading: false,
      blueSeaInfo: {},
      oasis: {}
    }
  },
  watch: {
    activeName (val) {
      if (val === 'rate' && !this.hasGetRate) {
        this.hasGetRate = true
      }
    }
  },
  mounted () {
    this.merchantId = this.$store.getters.userId
    this.readOnly = true
    this.isEdit = false
    if (this.activeName === 'info') {
      this.hasGetRate = false
    }
    this.getDetailsInfo()
  },
  methods: {
    /**
      * @description 查看或编辑时获取初始信息
    */
    getDetailsInfo () {
      let data = {
        merchantId: this.merchantId
      }
      const that = this
      data = qs.stringify(data)
      this.loading = true
      getMerchantInfo(data).then(data => {
        this.loading = false
        if (parseInt(data.result_cde) !== 0) {
          this.$message({
            showClose: true,
            message: data.result_msg,
            type: 'error'
          })
        } else {
          const pic = data.pics
          that.oasis.checkstandForOasis = pic.checkstandForOasis
          that.oasis.businessLicenseForOasis = pic.businessLicenseForOasis
          that.oasis.settledForOasis = pic.settledForOasis
          that.oasis.bdMerchantHeadForOasis = pic.bdMerchantHeadForOasis
          that.blueSeaInfo.cashierDeskForAliPay = pic.cashierDeskForAliPay
          that.blueSeaInfo.thirdPlatformSettledPic = pic.thirdPlatformSettledPic
        }
      })
    }
  }
}
</script>

<style scoped>
    .merchantDetails {
        padding:0 16px
    }
    .form-input {
        width: 450px;
    }
    .photos-content-view {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;
    }
    .photos-content-view .el-form-item{
        margin-right: 40px;
        width: 200px;
        text-align: center;
    }
</style>
<style>
    .merchantDetails .el-tabs__item{
        font-size: 18px;
    }
</style>
